import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetProctoringSessionReportByIdResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/getproctoring-session-report-by-id';
import { CreateProctoringAssessmentPayload, CreateProctoringAssessmentResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/create-proctoring-assessment';
import { CreateProctoringConfigurationPayload, PostProctoringConfigurationResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/create-proctoring-config';
import { CreateProctoringRulesetPayload, CreateProctoringRulesetResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/create-proctoring-ruleset';
import { DeleteConfigurationResponse, DeleteProctoringRuleResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/delete-proctoring-config';
import { GetProctoringPolicyBindingsPagedPayload, GetProctoringPolicyBindingsPagedResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/get-proctoring-assessment';
import { GetProctoringRulesetByIdResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/get-proctoring-by-ruleset-id';
import { GetProctoringConfigurationByIdResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/get-proctoring-config-by-id';
import { GetProctoringRulesetsPagedPayload, GetProctoringRulesetsPagedResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/get-proctoring-rulesets';
import { GetProctoringSessionReportsPagedPayload, GetProctoringSessionReportsPagedResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/get-proctoring-session';
import { GetProctoringConfigurationsPagedRequest, GetProctoringConfigurationsPagedResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/get-proctroing-config';
import { UpdateProctoringAssessmentPayload } from '@edtech-ui/core/models/proctoring-dashboard-models/update-proctoring-assessment';
import { UpdateProctoringConfigurationPayload, UpdateProctoringConfigurationResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/update-proctoring-config';
import { UpdateProctoringRulesetPayload } from '@edtech-ui/core/models/proctoring-dashboard-models/update-proctoring-ruleset';
import { PostProctoringRulesetPayload, UpdateProctoringRuleByIdResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/update-proctoring-rulesets';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { GetProctoringPolicyBindingByIdResponse } from '@edtech-ui/core/models/proctoring-dashboard-models/get-assessment-by-id';

@Injectable({
	providedIn: 'root'
})
export class ProctoringService {

	apiUrl = environment.proctoringApiUrl;

	constructor(private http: HttpClient) { }


	postProctoringConfiguration(payload: CreateProctoringConfigurationPayload): Observable<PostProctoringConfigurationResponse> {
		return this.http.post<PostProctoringConfigurationResponse>(`${this.apiUrl}/proctoringConfigurations`, payload);
	}


	getProctoringConfiguration(payload: GetProctoringConfigurationsPagedRequest): Observable<GetProctoringConfigurationsPagedResponse> {
		return this.http.post<GetProctoringConfigurationsPagedResponse>(`${this.apiUrl}/proctoringConfigurations/paged`, payload);
	}

	postProctoringRuleset(payload: CreateProctoringRulesetPayload): Observable<CreateProctoringRulesetResponse> {
		return this.http.post<CreateProctoringRulesetResponse>(`${this.apiUrl}/proctoringRuleSets`, payload);
	}


	getProctoringRuleset(payload: GetProctoringRulesetsPagedPayload): Observable<GetProctoringRulesetsPagedResponse> {
		return this.http.post<GetProctoringRulesetsPagedResponse>(`${this.apiUrl}/proctoringRuleSets/paged`, payload);
	}


	getProctoringRulesetById(ruleSetId: string): Observable<GetProctoringRulesetByIdResponse> {
		return this.http.get<GetProctoringRulesetByIdResponse>(`${this.apiUrl}/proctoringRuleSets/${ruleSetId}`);
	}


	postProctoringAssessment(payload: CreateProctoringAssessmentPayload): Observable<CreateProctoringAssessmentResponse> {
		return this.http.post<CreateProctoringAssessmentResponse>(`${this.apiUrl}/proctoringPolicyBindings`, payload);
	}


	getProctoringAssessment(payload: GetProctoringPolicyBindingsPagedPayload): Observable<GetProctoringPolicyBindingsPagedResponse> {
		return this.http.post<GetProctoringPolicyBindingsPagedResponse>(`${this.apiUrl}/proctoringPolicyBindings/paged`, payload);
	}


	getProctoringCandidate(payload: GetProctoringSessionReportsPagedPayload): Observable<GetProctoringSessionReportsPagedResponse> {
		return this.http.post<GetProctoringSessionReportsPagedResponse>(`${this.apiUrl}/proctoringSessions/reports/paged`, payload);
	}


	updateProctoringRuleset(payload: UpdateProctoringRulesetPayload, ruleSetId: string): Observable<any> {
		return this.http.patch<any>(`${this.apiUrl}/proctoringRuleSets/${ruleSetId}`, payload);
	}


	updateProctoringAssessment(payload: UpdateProctoringAssessmentPayload, policyBindingId: string): Observable<any> {
		return this.http.patch<any>(`${this.apiUrl}/proctoringPolicyBindings/${policyBindingId}`, payload);
	}


	deleteProctoringConfig(configId: string): Observable<DeleteConfigurationResponse> {
		return this.http.delete<DeleteConfigurationResponse>(`${this.apiUrl}/proctoringConfigurations/${configId}`);
	}


	deleteProctoringRuleset(rulesetId: string): Observable<DeleteConfigurationResponse> {
		return this.http.delete<DeleteConfigurationResponse>(`${this.apiUrl}/proctoringRuleSets/${rulesetId}`);
	}


	getProctoringConfigById(configId: string): Observable<GetProctoringConfigurationByIdResponse> {
		return this.http.get<GetProctoringConfigurationByIdResponse>(`${this.apiUrl}/proctoringConfigurations/${configId}`);
	}



	updateProctoringConfigById(configId: string, payload: UpdateProctoringConfigurationPayload): Observable<UpdateProctoringConfigurationResponse> {
		return this.http.patch<UpdateProctoringConfigurationResponse>(`${this.apiUrl}/proctoringConfigurations/${configId}`, payload);
	}



	deleteProctoringRulesetById(rulesetId: string, ruleId: string): Observable<DeleteProctoringRuleResponse> {
		return this.http.delete<DeleteProctoringRuleResponse>(`${this.apiUrl}/proctoringRuleSets/${rulesetId}/rules/${ruleId}`);
	}


	updateProctoringRulesetById(ruleSetId: string, ruleId: string, payload: PostProctoringRulesetPayload): Observable<UpdateProctoringRuleByIdResponse> {
		return this.http.patch<UpdateProctoringRuleByIdResponse>(`${this.apiUrl}/proctoringRuleSets/${ruleSetId}/rules/${ruleId}`, payload);
	}


	deleteProctoringAssessment(assessmentId: string): Observable<DeleteProctoringRuleResponse> {
		return this.http.delete<DeleteProctoringRuleResponse>(`${this.apiUrl}/proctoringPolicyBindings/${assessmentId}`);
	}


	getProctoringSessionsById(sessionId: string): Observable<GetProctoringSessionReportByIdResponse> {
		return this.http.get<GetProctoringSessionReportByIdResponse>(`${this.apiUrl}/proctoringSessions/reports/session/${sessionId}`);
	}


	getProctoringAssessmentById(policyBindingId: string): Observable<GetProctoringPolicyBindingByIdResponse> {
		return this.http.get<GetProctoringPolicyBindingByIdResponse>(`${this.apiUrl}/proctoringPolicyBindings/${policyBindingId}`);
	}


	postNewUpdateProctoringRule(ruleSetId: string, payload: any[]): Observable<any> {
		return this.http.post<any>(`${this.apiUrl}/proctoringRuleSets/${ruleSetId}/rules`, payload);
	}


}